'use strict';

import {localDataStorageProvider} from "../../services/localdatastorageprovider.js";
import {ListCtrl} from '../esfasi/listctrl.js';
import {indicatorModel} from "../../models/indicatormodel.js";

export class IndicatorsListCtrl extends ListCtrl
{
    storageNames = {
        query: 'IndicatorsListCtrlQuery'
    };
    type = '';
    $mdDialog;
    removeUrl;
    editUrl;
    canRemove = false;
    canEdit = false;
    linkEl;

    constructor($scope, $http, $filter, $timeout, $locale, jsDataService, $mdDialog){
        super($scope, $http, $filter, $timeout, $locale, jsDataService);

        this.cfgExportUrl = this.jsDataService.get('cfgExportUrl', '');
        this.cfgAddUrl = this.jsDataService.get('cfgAddUrl');
        this.editUrl = this.jsDataService.get('cfgEditUrl', '');
        this.type = this.jsDataService.get('cfgType', '');
        this.$mdDialog = $mdDialog;

        this.storageNames.query = 'Indicators'+this.type+'ListCtrlQuery';

        if(this.type === 'manual'){
            this.removeUrl = this.jsDataService.get('cfgRemoveUrl', '');
            this.canRemove = (this.removeUrl !== '');
            this.canEdit = (this.editUrl !== '');
        }

        const filteredClassif = this.filterClassifActive(this.jsDataService.get('cfgClassif', {}));
        if(this.jsDataService.set){
            this.jsDataService.set('cfgClassif', filteredClassif);
        }
    }

    filterClassifActive(classificators){
        const filtered = {};
        for (const name of Object.keys(classificators || {})) {
            const items = classificators[name];
            if (Array.isArray(items)) {
                filtered[name] = items.filter(entry => typeof entry.active === 'undefined' || String(entry.active) === '1');
            } else {
                filtered[name] = items;
            }
        }
        return filtered;
    }

    initQuery(){
        const params = ['value'];
        this.defaultQuery = angular.merge({}, this.getDefaultQuery(), this.jsDataService.get('cfgQuery', {}));
        const tiny = this.getTinyDataForStorage(this.defaultQuery.filters, params);
        let storing = angular.copy(this.defaultQuery);
        storing.filters = tiny;
        const stored = new localDataStorageProvider2(this.storageNames.query, storing);
        this.query = angular.merge({}, this.defaultQuery, stored.getData());

        if(this.query.filters.query.value !== ''){
            this.queryValueCopy = this.query.filters.query.value;
        }

        const self = this;
        this.$scope.$watch(function(){
            return angular.toJson(self.query);
        },function(){
            let toStore = angular.copy(self.query);
            toStore.filters = self.getTinyDataForStorage(toStore.filters, params);
            stored.setData(toStore);
            self.setChips();
            self.loadData();
        });
    }

    setData(data){
        this.data = [];
        for(let ln of data){
            this.data.push(new indicatorModel(ln, this.$filter, this.jsDataService));
        }
    }

    getColValue(row, col){
        if(typeof(row[col]) === 'undefined'){
            return '';
        }
        if(row instanceof indicatorModel){
            return row.getValue(col);
        }
        return row[col];
    }

    getFooterData(col){
        return '';
    }

    exportList(){
        const query = new URLSearchParams({
            filters: JSON.stringify(this.query.filters),
        });

        const ts = new Date().toISOString().substring(0, 19).replace(/-|:|T/g, '');

        if(typeof(this.linkEl) === 'undefined'){
            this.linkEl = document.createElement('a');
            this.linkEl.style.display = 'none';
            document.body.appendChild(this.linkEl);
        }

        this.linkEl.href = `${this.cfgExportUrl}?${query.toString()}`;
        this.linkEl.download = `Indicator_${this.type}_${ts}.xlsx`;
        this.linkEl.click();
    }

    addValue(ev){
        this.openValueDialog(ev, null).then((results) => {
            if (this.cfgAddUrl) {
                this.$scope.basicHttpConfigProcess({
                    url: this.cfgAddUrl,
                    method: 'POST',
                    data: results
                }).then((response) => {
                    if(response.data && response.data.success){
                        this.loadData();
                    }
                });
            }
        }, function(){});
    }

    editValue(ev, row){
        if(!this.canEdit){
            return;
        }
        if(!(row instanceof indicatorModel)){
            return;
        }

        this.openValueDialog(ev, row).then((results) => {
            if (this.editUrl) {
                this.$scope.basicHttpConfigProcess({
                    url: this.editUrl,
                    method: 'POST',
                    data: results
                }).then((response) => {
                    if(response.data && response.data.success){
                        this.loadData();
                    }
                });
            }
        }, function(){});
    }

    openValueDialog(ev, existingRow){
        const self = this;
        return this.$mdDialog.show({
            controller: ["$scope", "$mdDialog", "$filter", "jsDataService", function($scope, $mdDialog, $filter, jsDataService){
                self.addValueDlg($scope, $mdDialog, $filter, jsDataService, existingRow);
            }],
            templateUrl: 'indicators/ng_addvalue_dlg.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: true
        });
    }

    addValueDlg($scope, $mdDialog, $filter, jsDataService, existingRow) {

        $scope.classif = jsDataService.get('cfgClassif', {});

        if(existingRow){
            $scope.indicatorValue = {
                id: existingRow.id,
                date_cet: new Date(parseInt(existingRow.date, 10) * 1000),
                invitation_id: Array.isArray(existingRow.invitation_ids) ? existingRow.invitation_ids.slice() : [],
                project_id: Array.isArray(existingRow.project_ids) ? existingRow.project_ids.slice() : [],
                indicator_id: parseInt(existingRow.indicator_id || 0),
                unit_id: parseInt(existingRow.unit_id || 0),
                value: parseFloat(existingRow.value || existingRow.total_value || 0)
            };
            $scope.dialogTitle = (jsDataService.t) ? jsDataService.t('edit_indicator_value') : 'Edit';
        } else {
            $scope.indicatorValue = {
                date_cet: new Date(),
                invitation_id: [],
                project_id: [],
                indicator_id: 0,
                unit_id: 0,
                value: null
            };
            $scope.dialogTitle = (jsDataService.t) ? jsDataService.t('add_indicator_value') : 'Add';
        }

        function getSelectedProject(){
            if(Array.isArray($scope.indicatorValue.project_id) && $scope.indicatorValue.project_id.length === 1){
                let pid = $scope.indicatorValue.project_id[0];
                let r = $filter('filter')($scope.classif.projects, {id: pid}, true);
                if(r.length > 0){
                    return r[0];
                }
            }
            return null;
        }

        $scope.invitationChanged = function(){
            const project = getSelectedProject();
            if(project && Array.isArray($scope.indicatorValue.invitation_id)){
            }
        };

        $scope.projectChanged = function(){
            const project = getSelectedProject();
            if(project && Array.isArray($scope.indicatorValue.invitation_id)){
            }
        };

        $scope.close = function () {
            $mdDialog.cancel();
        };

        $scope.submitDialog = function () {
            $scope.indicatorValue.date = $filter('date')($scope.indicatorValue.date_cet, 'yyyy-MM-dd');
            $mdDialog.hide($scope.indicatorValue);
        };
    }

    removeValue(ev, item){
        if(this.canRemove && item instanceof indicatorModel){
            const confirmTexts = this.jsDataService.get('removeValueConfirmTexts');
            const confirm = this.$mdDialog.confirm()
                .title(confirmTexts.title)
                .htmlContent(confirmTexts.content)
                .ariaLabel(confirmTexts.title)
                .targetEvent(ev)
                .ok(confirmTexts.ok)
                .cancel(confirmTexts.cancel);
            this.$mdDialog.show(confirm).then(() => {
                this.$scope.basicHttpConfigProcess({
                    url: this.removeUrl,
                    method: 'GET',
                    responseType: 'json',
                    params: {
                        id: item.id
                    }
                }).then((results) => {
                    if(results.data.success){
                        this.loadData();
                    }
                });
            }, () => {});
        }
    }
}

export class localDataStorageProvider2 extends localDataStorageProvider
{
    setData(newdata){
        this.data = newdata;
        for(let n in this.data.filters) {
            const filter = this.data.filters[n];

            if(filter.value && filter.value instanceof Date){
                filter.value.setTime(filter.value.getTime() - (filter.value.getTimezoneOffset() * 60000));
                filter.value = filter.value.toISOString();
            }
        }
        this.storeData();
    }
}
